import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { HealthSystemSetup } from "src/app/core/model/v2/practice/HealthSystemSetup";

@Component({
  selector: "app-health-system-picker",
  templateUrl: "./health-system-picker.component.html",
  styleUrls: ["./health-system-picker.component.scss"],
})
export class HealthSystemPickerComponent implements OnInit, OnChanges {
  @Input() healthSystems: HealthSystemSetup[];
  @Input() practiceType: number = 0;
  @Input() selectedIds: number[];
  @Output() selectedIdsChange = new EventEmitter<number[]>();

  constructor() {}

  ngOnInit() {}
  ngOnChanges() {
    this.healthSystems = this.healthSystems.filter(
      (x) => x.practiceType == this.practiceType
    );
  }
  onSelectedChange(npis: number[]) {
    this.selectedIdsChange.emit(npis);
  }
}
